import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import KhuCongNghiep from './khu-cong-nghiep';
import KhuCongNghiepDetail from './khu-cong-nghiep-detail';
import KhuCongNghiepUpdate from './khu-cong-nghiep-update';
import KhuCongNghiepDeleteDialog from './khu-cong-nghiep-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={KhuCongNghiepUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={KhuCongNghiepUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={KhuCongNghiepDetail} />
      <ErrorBoundaryRoute path={match.url} component={KhuCongNghiep} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={KhuCongNghiepDeleteDialog} />
  </>
);

export default Routes;
